import { detect } from 'detect-browser';

export type BrowserInfo = {
  majorVersion: number;
  name: string;
  os: null | string;
  type: string;
  unsupported: boolean;
  version: null | string;
};

type MinimumSupportedBrowserVersions = {
  [key: string]: number;
};

// these are the minimum supported major versions of browsers.
// browser identifiers are defined here:
// https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
const minSupportedBrowserVersions: MinimumSupportedBrowserVersions = {
  chrome: 21,
  edge: 12,
  firefox: 28,
  ie: 11,
  opera: 12,
  safari: 7
};

const checkBrowser = (): BrowserInfo => {
  const browser = detect()!;
  const version = browser.version!.split('.');
  const majorVersion = Number(version[0]) || 0;

  let unsupported = false;

  if (browser.name) {
    const minSupportedVersion = minSupportedBrowserVersions[browser.name];
    if (minSupportedVersion && majorVersion < minSupportedVersion) {
      unsupported = true;
    }
  }

  return {
    majorVersion,
    name: browser.name,
    os: browser.os,
    type: browser.type,
    unsupported,
    version: browser.version
  };
};

export default checkBrowser;
